import React, { useEffect, useState } from 'react';

import { Button, Icon } from '@digital/ui';
import { Tooltip } from 'antd';
import api from '@app/api/api';
import { Visibility } from '../Visibility';

export interface UploadPropsForm {
  key: string;
  value: any;
}

export interface UploadMultProps {
  enderecoApi: string;
  listUploadPropsForm: UploadPropsForm[];
  hasFile?: boolean;
  iconName?: React.ComponentProps<typeof Icon>['name'];
  label?: string | undefined;
  showLabel?: boolean;
  tooltip?: string | undefined;
  buttonClass?: string | undefined;
  retorno: (data: any) => void;
  nameFieldFileInApi?: string;
  idDoComponente: string;
  visible?: boolean;
}

export const UploadMultProps = ({
  tooltip,
  enderecoApi,
  retorno,
  iconName,
  hasFile,
  label,
  buttonClass,
  listUploadPropsForm,
  showLabel = true,
  nameFieldFileInApi = 'File',
  idDoComponente,
  visible = true,
}: UploadMultProps) => {
  const nameIcon = iconName ? iconName : 'ui-upload';

  const teveMudanca = () => {
    const input = document.getElementById(idDoComponente) as HTMLInputElement;
    if (!input) {
      return;
    }

    const curFiles = input.files;

    if (!curFiles) {
      return;
    }

    const form = new FormData();
    form.append(nameFieldFileInApi, curFiles[0]);

    listUploadPropsForm.forEach(item => {
      form.append(item.key, item.value);
    });

    api
      .post(enderecoApi, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(data => {
        input.value = '';
        retorno(data);
      });
  };

  const triggerMudanca = () => {
    const input = document.getElementById(idDoComponente);
    if (input) {
      input.click();
    }
  };

  return (
    <Visibility visible={visible}>
      <Tooltip title={tooltip}>
        <input
          type="file"
          onChange={teveMudanca}
          id={idDoComponente}
          className="custom-input-type-file"
          style={{ cursor: 'pointer !important', display: 'none' }}
        />
        <Button
          icon={nameIcon}
          onClick={() => triggerMudanca()}
          className={(hasFile ? 'has-comments ' : '') + buttonClass}
          title={showLabel ? label : ''}
        />
      </Tooltip>
    </Visibility>
  );
};
